import { PlatformEnum } from 'constants-activate';
import { IntegrationDefinition } from '../IntegrationDefinition';
import {
  IntegrationCategoryEnum,
  IntegrationProviderEnum,
  IntegrationTypeEnum,
} from 'constants-integrations';

const RitualDefinition: IntegrationDefinition = {
  name: IntegrationProviderEnum.Ritual,
  allowsMultipleInstances: false,
  hasCustomUI: true,
  friendlyName: 'Ritual Integration',
  description: `Defines the required properties for a Ritual integration.`,
  category: IntegrationCategoryEnum.FoodOrdering,
  platforms: [PlatformEnum.Mobile, PlatformEnum.Web],
  type: IntegrationTypeEnum.WebView,
  settings: {},
  properties: {},
};

export const definition = RitualDefinition;
